import React, { useState } from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import ButtonComponent from '../common/ButtonComponent';
import plusIcon from '../../images/icons/plus_icon.svg';

const CreatePOButton = ({ goToCreatePage, canCreateCrew, canCreateVessel, canCreateAgency }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (type) => {
    handleClose();
    goToCreatePage(type);
  };

  return (
    <>
      <ButtonComponent name="Create PO" icon={plusIcon} handleClick={handleClick}>
        Create PO
      </ButtonComponent>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        getContentAnchorEl={null}
        style={{ marginTop: '8px' }}
      >
        {canCreateCrew && <MenuItem onClick={() => handleOptionClick('crew')}>Crew PO</MenuItem>}
        {canCreateVessel && <MenuItem onClick={() => handleOptionClick('vessel')}>Vessel PO</MenuItem>}
        {canCreateAgency && <MenuItem onClick={() => handleOptionClick('agency')}>Agency PO</MenuItem>}
      </Menu>
    </>
  );
};

export default CreatePOButton;
